import { Component, OnInit, Input, Output, TemplateRef, ViewContainerRef, EventEmitter } from '@angular/core';
@Component({
    selector: 'app-dialog-footer',
    templateUrl: './dialog-footer.component.html',
    styleUrls: ['./dialog-footer.component.css'],
    standalone: false
})
export class DialogFooterComponent implements OnInit {
    @Input() template: TemplateRef<any>;
    @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
    constructor(private vcr: ViewContainerRef) {}

    ngOnInit() {
        this.vcr.createEmbeddedView(this.template);
        // this.dialogService.getFooterEvent().subscribe((data)=>{
        //   this.onClick(data);
        // });
    }

    onClick(data) {
        this.clicked.emit(data);
    }
}
